import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import Grid from "../components/Grid/Grid";
import Footer from "../components/Footer/Footer";

function Portfolio() {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        src="https://images.unsplash.com/photo-1545665277-5937489579f2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
        alt="image code"
        type="img"
        title="Portfolio"
        btnClass="hide"
      />

      <Grid />
      <Footer />
    </>
  );
}

export default Portfolio;
